const ONE_TIME_PASSWORD_TYPES = {
    pin: "pin",
    otp: "otp",
    web: "web",
    webReset: "web-reset",
    signUp: "signup"
}

const DELIMITER = "<<@>>"

const getPartsByDelimiter = (value) => {
    return value.split(DELIMITER)
}
const INPUT_PHONE_DEFAULT_OPTIONS = {
    defaultCountries: {
        us: {
            code: "US",
            value: "+1"
        }
    },
    maxLength: {
        us: 12,
        other: 100
    },
    zipMaxLength: {
        us: 5,
        other: 100
    }
}

export {ONE_TIME_PASSWORD_TYPES, getPartsByDelimiter, DELIMITER, INPUT_PHONE_DEFAULT_OPTIONS}
